import { FieldType } from '../../../types/Field.type';
export const StreetAddress2 = {
    priority: Number.MAX_VALUE,
    label: 'fields.common.address.street_address2.label',
    fallbackLabel: 'Address line 2',
    mandatory: (payload, path) => false,
    disabled: (payload, path) => false,
    applicable: (payload, path) => false,
    applicableDependsOn: ['../country'],
    type: FieldType.String,
    trackFieldValueWithAnalytics: false,
};
